import { useState, useEffect } from 'react';

interface User {
  user_id: string;
  email: string;
  password: string;
  twofa_enabled?: number;
  is_admin?: boolean;
  disclaimer_accepted?: boolean;
  disclaimer_accepted_at?: string | null;
  preferred_language?: string | null;
}

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        // Проверяем, есть ли сохраненный пользователь в localStorage
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
          const parsedUser = JSON.parse(savedUser);
          
          // Получаем актуальную информацию о пользователе через API
          try {
            const apiBase = process.env.REACT_APP_API_URL;
            if (apiBase && parsedUser.user_id) {
              const base = apiBase.replace(/\/$/, '');
              const url = base.endsWith('/api') ? `${base}/users/me` : `${base}/api/users/me`;
              
              const response = await fetch(`${url}?user_id=${parsedUser.user_id}`);
              
              if (response.ok) {
                const userData = await response.json();
                // Обновляем данные пользователя, включая preferred_language
                parsedUser.disclaimer_accepted = userData.disclaimer_accepted;
                parsedUser.disclaimer_accepted_at = userData.disclaimer_accepted_at;
                parsedUser.preferred_language = userData.preferred_language;
              }
              
              // Проверяем актуальный статус админа
              const adminUrl = base.endsWith('/api') ? `${base}/admin/check_admin` : `${base}/api/admin/check_admin`;
              const adminResponse = await fetch(adminUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  user_id: parseInt(parsedUser.user_id),
                  email: parsedUser.email
                })
              });
              
              if (adminResponse.ok) {
                const adminData = await adminResponse.json();
                parsedUser.is_admin = adminData.is_admin;
              }
            }
          } catch (apiError) {
            // Если API не доступен, используем сохраненные данные
            console.warn('Не удалось получить актуальные данные пользователя:', apiError);
          }
          
          setUser(parsedUser);
        }
      } catch (error) {
        console.error('Ошибка при получении пользователя:', error);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, []);

  return { user, loading };
}; 